export default __webpack_public_path__ + "assets/check-dc79bac.svg";